/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'photo-camera': {
    width: 16,
    height: 16,
    viewBox: '0 0 23 19',
    data: '<path pid="0" d="M3.6 18.5C2 18.5.7 17.2.7 15.6V6C.7 4.4 2 3.1 3.6 3.1h2.8L7.3.8c.1-.2.3-.3.5-.3h7.4c.2 0 .4.1.5.3l.9 2.3h2.8c1.6 0 2.9 1.3 2.9 2.9v9.5c0 1.6-1.3 2.9-2.9 2.9H3.6zm0-1.1h15.9c1 0 1.8-.8 1.8-1.8V6c0-1-.8-1.8-1.8-1.8h-3.2c-.2 0-.4-.1-.5-.3l-.9-2.3H8.2l-1 2.3c0 .2-.2.3-.5.3H3.6C2.5 4.2 1.7 5 1.7 6v9.5c0 1.1.8 1.9 1.9 1.9zm7.9-1.6c-2.8 0-5-2.3-5-5 0-2.8 2.3-5 5-5 2.8 0 5 2.3 5 5 0 2.8-2.2 5-5 5zm0-1c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4z" fill-rule="evenodd" clip-rule="evenodd"/>'
  }
})
